import { Directive, Input } from '@angular/core';
import { BaseValidator } from './base.directive';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { ValidationTypes } from './validator-const.model';
import { TranslationService } from '../../common/services/translation.service';

const START_WITH_WHITE_SPACE_REGEX = /^(\s)+/;

@Directive({
    selector: `[cpqCannotStartWithWhiteSpace]`,
    providers: [{ provide: NG_VALIDATORS, useExisting: CpqCannotStartWithWhiteSpaceDirective, multi: true }],
    standalone: false
})
export class CpqCannotStartWithWhiteSpaceDirective extends BaseValidator implements Validator {

  constructor(private translationService: TranslationService) {
    super();
  }

  validate(c: AbstractControl): { [key: string]: any; } {
      const value = typeof (c.value) === 'number' ? c.value.toString() : c.value;
      if (START_WITH_WHITE_SPACE_REGEX.test(value)) {
        return this.createMessage(ValidationTypes.cpqRequired, this.translationService.translate('Msg.CannotStartWithWhiteSpace'));
      } else {
        return null;
      }
  }
}
